// @ts-nocheck
import { Button, Col } from "antd";
import React from "react";
import existing_no_data from '../../assets/existing-no-data.svg'
import { useHistory } from "react-router-dom";
import { compose } from "modules/core";
import { withMe } from "modules/user/containers/UserOperations";
import { withApollo } from '@apollo/client/react/hoc';
import { SEND_LOG_TO_BACKEND } from "modules/look/graphql/LogError.gql";
import { GET_ALL_GROUPS_QUERY } from "modules/poc-dashboard/account-manager/graphql/am-permission-queries.gql";
// import error_banner from '../../assets/error-page-banner.svg'
// import error_ticket_icon from '../../assets/error-page-ticket-icon.svg'
// import support_route from 'modules/ticketing-system/route';

const NoPermissionView = (props) => {
    const { content, client } = props
    const [missing_permission_groups, setMissingPermissionGroups] = React.useState([]);
    const history = useHistory()
    const sendLogToBackend = async (msg) => {
        await client.query({
            query: SEND_LOG_TO_BACKEND,
            variables: { msg: msg },
            fetchPolicy: 'network-only',
        });
    }

    const sendErrorLog = (ungroupedPermissions, missingPermissionGroups) => {
        try {
            if (localStorage.hasOwnProperty("routeHistory")) {
                const routeArray = localStorage.routeHistory.split(",");
                const lastUniqueRoutes = routeArray.slice(-20);
                const msg = {
                    TYPE: "UI_PERMISSION_ERROR",
                    CURRENT_ROUTE: lastUniqueRoutes[lastUniqueRoutes.length - 1],
                    ROUTE_HISTORY: lastUniqueRoutes.join(","),
                    MISSING_PERMISSIONS_GROUP: missingPermissionGroups.join(),
                    ungrouped_permissions: ungroupedPermissions.join()
                };
                sendLogToBackend(JSON.stringify(msg))
                localStorage.removeItem("routeHistory")
            }
        } catch (error) {
            console.error("Error sending log to backend", error);
        }
    }

    const getMissingPermissions = async () => {
        try {
            if (localStorage.hasOwnProperty("missing_permissions")) {
                const missingPermissionSet = new Set();
                const permissionsArray = localStorage.getItem("missing_permissions");
                const paramGroups = await getParamGroups();

                let permissions = [];
                try {
                    permissions = permissionsArray ? JSON.parse(permissionsArray).flat() : [];
                } catch (e) {
                    console.error("Failed to parse missing_permissions from localStorage", e);
                    permissions = [];
                }

                const ungroupedPermissions = [];
                for (const permission of permissions) {
                    let found = false;
                    for (const [groupName, perms] of Object.entries(paramGroups)) {
                        if (perms.includes(permission)) {
                            missingPermissionSet.add(groupName);
                            found = true;
                            break;
                        }
                    }

                    if (!found) {
                        ungroupedPermissions.push(permission);
                    }
                }
                setMissingPermissionGroups(Array.from(missingPermissionSet));
                sendErrorLog(ungroupedPermissions, Array.from(missingPermissionSet));
            } else {
                sendErrorLog(["If current route is not survey or tool, any permission might be missing from UI codebase"], ["If current route is tool or survey then please check if it is assigned and public"]);
            }
        } catch (error) {
            console.error("Error fetching missing permissions", error);
        }
    }

    const getParamGroups = async () => {
        try {
            const { data } = await client.query({
                query: GET_ALL_GROUPS_QUERY,
                fetchPolicy: 'network-only'
            });
            if (data && data.getAllGroups) {
                return data.getAllGroups.edges.reduce((acc, ele) => {
                    acc[ele.node.name] = ele.node?.permissions?.length
                        ? ele.node.permissions.map(p => p.codename)
                        : [];
                    return acc;
                }, {});
            }

            return [];
        }
        catch (e) {
            console.error("organizationHomeContainer -> verticalCount", e)
        }
    }

    React.useEffect(() => {
        try {
            getMissingPermissions();
        } catch (error) {
            console.error("Error Processing Permissions", error)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    return (
        <>
            <div className="kudos-root-class kudos-existing-no-data">
                <img src={existing_no_data} className="kudos-no-data-img" alt="" />
                <Col align="center" className="kudos-root-class">
                    <h4 className="kuods-not-found">{content ? content : "You don't have permission to view this page"}</h4>
                    {!!missing_permission_groups.length && < h4 className="kudos-no-data-text">Please contact your account manager for following permissions: {missing_permission_groups.join(", ")}</h4>}
                    <Button onClick={() => { history.goBack() }} className="kudos-go-back-btn">Go Back</Button>
                </Col>
            </div >
            {/* <div className="kudos-root-class kudos-existing-no-data error-boundry-container" style={{background:"#fff",borderRadius:"1em"}}>
                <img className="error-boundry-image" src={error_banner} alt="error_banner"/>
                <h1 className='error-bountry-title-head'>Opps! Something Went Wrong</h1>
                <h4 className="error-permission-warning-text">{content ? content : "You don't have permission to view this page"}</h4>
                <div style={{display:'flex',flexDirection:"row",justifyContent:'center',alignItems:'center',gap:"1em",flexWrap:'wrap'}}>
                    <Button className='error-boundry-btn' onClick={() => { history.goBack() }}><span style={{paddingTop:"5px"}}>Go Back</span></Button>
                    <Button className='error-boundry-btn' style={{position:"relative"}} onClick={()=>{history.push(support_route.create_ticket)}}> <img style={{ position: "absolute", left: '0px', top: "-12px", height: "1.5em", width: '1.5em' }} src={error_ticket_icon} alt="error_ticket_icon" /> <span style={{paddingTop:"5px"}}>Raise Ticket</span></Button>
                </div>
            </div> */}
        </>
    )

}

export default compose(withMe, withApollo)(NoPermissionView)